import { Outlet } from 'react-router-dom'
import { ThemeProvider } from '@/context/ThemeContext'
import { ScrollToTop } from '@/components/ScrollToTop'

export function RootLayout() {
  return (
    <ThemeProvider>
      <ScrollToTop />
      <Outlet />
    </ThemeProvider>
  )
}
